import React from "react";
import { Link } from "react-router-dom";
import { fmtDay } from "@/components/timemachine/DailyReports";

const fmtShort = (s) => new Date(`${s}T00:00:00`).toLocaleDateString("it-IT", { day: "numeric", month: "short" });
const STATUS = {
    completata: "text-green-700",
    spostata: "text-amber-700",
    "non completata": "text-neutral-500",
};

function PlanGroup({ g }) {
    const c = g.counts;
    return (
        <div className="rounded-md border border-neutral-200 bg-white p-4" data-testid={`tm-plan-${g.date}-${g.user_id}`}>
            <div className="flex items-baseline justify-between gap-3 mb-2">
                <Link to={`/piani-giornalieri?u=${g.user_id}&d=${g.date}`} className="text-sm font-medium text-neutral-900 hover:underline">{g.user}</Link>
                <span className="text-xs text-neutral-500" data-testid={`tm-plan-counts-${g.date}-${g.user_id}`}>
                    {c.completate}/{c.previste} completate{c.spostate ? ` · ${c.spostate} spostate` : ""}
                </span>
            </div>
            <ul className="space-y-1">
                {g.items.map((x) => (
                    <li key={x.id} className="text-sm flex gap-2 items-baseline" data-testid={`tm-plan-item-${x.id}`}>
                        <span className={`text-[11px] shrink-0 w-28 ${STATUS[x.status]}`}>
                            {x.status === "spostata" ? `spostata al ${fmtShort(x.moved_to)}` : x.status}
                        </span>
                        <span className={x.status === "completata" ? "text-neutral-900" : "text-neutral-600"}>
                            {x.link ? <Link to={x.link} className="hover:underline">{x.title}</Link> : x.title}
                            {x.project_title && <span className="text-xs text-neutral-400"> · {x.project_title}{x.client_name ? ` (${x.client_name})` : ""}</span>}
                        </span>
                    </li>
                ))}
            </ul>
        </div>
    );
}

export function DailyPlansDigest({ plans, single }) {
    if (!plans?.length) return <div className="text-sm text-neutral-500 border border-dashed border-neutral-300 rounded-md p-6 bg-white" data-testid="tm-plans-empty">Nessun piano giornaliero {single ? "per questo giorno" : "in questo intervallo"}.</div>;
    const days = [...new Set(plans.map((g) => g.date))];
    return days.map((d) => (
        <div key={d} className="space-y-2">
            {!single && <div className="text-xs uppercase tracking-wider text-neutral-500 font-semibold capitalize">{fmtDay(d)}</div>}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                {plans.filter((g) => g.date === d).map((g) => <PlanGroup key={g.user_id} g={g} />)}
            </div>
        </div>
    ));
}
